/**
 * Trigger a browser download of in-memory content as a file.
 *
 * Wraps the standard Blob + object-URL + programmatic-anchor-click +
 * URL-revoke dance that browsers require to save raw content to disk.
 *
 * `content` can be a string, ArrayBuffer, typed array, or an already-built
 * Blob. When it's already a Blob, the blob's own type is used and the
 * mimeType argument is ignored — useful for callers that get a Blob back
 * from `fetch().blob()` or axios `responseType: 'blob'`.
 */
export function downloadAsFile(content, filename, mimeType = 'text/plain') {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
